import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export const BaseTarget = _ref => {
  let {
    id,
    component: Component = 'div',
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Component, {
    ...otherProps,
    id: id,
    tabIndex: "-1"
  });
};
const Target = styled(BaseTarget)`
  outline: none;
`;
Target.displayName = 'Target';
export default Target;